<template>
  <div v-if="collectionDocument" class="collection">
    <blocks
      :blocks="collectionDocument.blocks"
      :origin="origin"
      :entities="{ collection: collectionDocument, products, questionnaires }"
      is-on-top-of-page
    />
  </div>
</template>

<script>
import ScrollTrackingMixin from '@/mixins/ScrollTrackingMixin'
import Blocks from '@/components/blocks/Blocks'

import services from '@/services'
import { ORIGIN } from '@/const'

export default {
  name: 'Collection',
  components: {
    Blocks,
  },
  mixins: [ScrollTrackingMixin],
  async asyncData({ params, $logError, i18n, payload, error }) {
    if (payload && payload.collectionDocument) {
      return {
        collectionDocument: payload.collectionDocument,
      }
    }

    try {
      // Query to get post content

      const collectionDocument = await services.sanityService
        .getCollection({
          context: params.context,
          uid: params.uid,
          lang: i18n.locale.slice(0, 2),
        })
        .then((res) => {
          if (res.length > 0) {
            return res[0]
          }

          return null
        })

      if (!collectionDocument) {
        throw new Error('collection-not-found')
      }

      // Returns data to be used in template
      return {
        collectionDocument,
      }
    } catch (e) {
      // Returns error page
      // if (e.message !== 'collection-not-found') {
      $logError.captureException(e)
      // }
      error({ statusCode: 404, message: 'Page not found' })
    }
  },
  data() {
    return {
      collectionDocument: null,
      products: [],
      questionnaires: [],
    }
  },
  head() {
    if (this.collectionDocument) {
      const route = `${
        process.env.BASE_URL ? process.env.BASE_URL : 'https://www.asphalte.com'
      }${this.$nuxt.$route.path}`

      const head = services.pageService.getHead(
        {
          type: 'collection',
          title: this.collectionDocument.title,
          route,
          sanity: this.collectionDocument,
          defaultTitle: this.$t('seo.defaultTitle'),
          defaultDesc: this.$t('seo.defaultDesc'),
        },
        this.$generateAlternateLinksMetaSanity(
          this.collectionDocument._type,
          this.collectionDocument.alternate_languages
        )
      )

      return head
    }

    return {}
  },
  computed: {
    origin() {
      if (
        this.$route.params.uid === 'eshop' ||
        this.$route.params.uid === 'e-shop'
      ) {
        return ORIGIN.ESHOP
      }

      return ORIGIN.AGENDA
    },
  },
  mounted() {
    this.$track.page(this.$metaInfo, this.$route, this.$nuxt.context.from)
  },
}
</script>
